import noUiSlider from "nouislider";
import {objectsEqual} from "./Helpers";

class AbstractFilters{

    constructor(triggerUpdate){

        this.filterRadiusElement = null;
        this.filterResetElement = null;

        this.triggerUpdate = triggerUpdate;

        this.stateDefault = {};
        this.state = {};

    }

    updateFilters(){

        let self = this;

        self.changeFilterResetBtn();

        $(document).trigger(self.triggerUpdate);
    }

    hideRaius(){
        this.filterRadiusElement.addClass('hide');
        this.filterRadiusElement.trigger('hide');
    }

    showRadius(){
        this.filterRadiusElement.removeClass('hide')
    }

    renderRadius(){

        let self = this;

        let el = $('<div class="filterRadius hide">' +
            '<input type="hidden" value="" name="radius">' +
            '<div class="dropdown">' +
            '<button type="button" class="dropdown_button">' +
            '<span class="flex-col gap_1">' +
            '<span class="flex-row align-items-center gap_1">' +
            '<i class="icon-event_point"></i> <span>Radius</span> <i class="icon-chevron-down transitionTransform"></i>' +
            '</span>' +
            '<span class="text-center color-b800 filterDisplayVal">500 km</span>' +
            '</span>' +
            '</button>' +
            '<div class="dropdown_menu">' +
            '<div class="" style="width: 400px; padding: 10px 20px 20px 20px; user-select: none">' +
            '<div style="font-size: 1.2em; padding-bottom: 10px">Showing in a radius</div>' +
            '<div class="flex-row flex-between">' +
            '<div class="range-slider-fromval"></div>' +
            '<div class="range-slider-toval"></div>' +
            '</div>' +
            '<div class="range-slider"></div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>');

        let input_radius = el.find('input[name=radius]');
        let sliderRadius = el.find('.range-slider');
        let sliderRadiusDisplayVal = el.find('.filterDisplayVal');

        let sliderObject = noUiSlider.create(sliderRadius[0], {
            start: [(self.state.radius || 500)],
            step: 50,
            connect: [true, false],
            range: {
                'min': 50,
                'max': 1000
            }
        });
        sliderObject.on('update', function(values){
            el.find('.range-slider-fromval').html(Math.round(values[0]) + ' km');
        })
        sliderObject.on('change', function(values){
            input_radius.val(Math.round(values[0]));
            self.state.radius = Math.round(values[0]);

            sliderRadiusDisplayVal.html(Math.round(values[0]) + ' km');

            self.updateFilters();
        })

        el.on('hide', function(){
            sliderRadiusDisplayVal.html(500 + 'km');
            self.state.radius = null;
            input_radius.val('');
            sliderObject.reset();
            self.changeFilterResetBtn();
        })

        self.container.on('reset', function(){
            sliderRadiusDisplayVal.html(500 + 'km');
            self.state.radius = null;
            input_radius.val('');
            sliderObject.reset();
        })

        if(self.state.radius){
            input_radius.val(self.state.radius);
            sliderRadiusDisplayVal.html(self.state.radius + 'km');
            el.removeClass('hide');
        }

        return el;

    }

    renderResetBtn(){

        let self = this;

        let el = $('<div class="resetFilters flex-col hide pointer"><span class="color-r1000 p_10">Reset filters</span></div>');

        el.find(' > span').on('click', function(){
            el.addClass('hide');
            self.container.trigger('reset');
            self.updateFilters();
        })

        return el;

    }

    /**
     * Изменить состояние кнопки reset
     */
    changeFilterResetBtn(){

        let self = this;

        if(objectsEqual(this.stateDefault, this.state)){
            this.filterResetElement.addClass('hide');
        }else{
            this.filterResetElement.removeClass('hide');
        }

    }

}

export default AbstractFilters;